// themeReducer.js

import { SET_THEME } from "../actions/ThemeAction";

const initialState = {
    theme: null,
};

const themeReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_THEME:
            return {
                ...state,
                theme: action.data,
            };
        default:
            return state;
    }
};

export default themeReducer;